import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { Select, InputBase, Tabs, Tab, Radio, Checkbox, FormControlLabel, Switch } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const NextButton = styled(Button)({
  'borderRadius': '8px',
  'padding': '12px',
  'display': 'flex',
  'justifyContent': 'center',
  'alignItems': 'center',
  'gap': '10px',
  'background': 'linear-gradient(104deg, #4361EE 10.06%, #4895EF 88.31%, #4CC9F0 153.14%)',
  'color': '#F5FAFF',
  'textAlign': 'center',
  'fontFamily': 'Inter',
  'fontSize': '14px',
  'fontStyle': 'normal',
  'fontWeight': 600,
  'lineHeight': '24px',
  'textTransform': 'none',
  '&:disabled': {
    background: '#4A4C51',
    color: '#F5FAFF',
  },
});
const BackButton = styled(Button)({
  'borderRadius': '8px',
  'border': '1px solid #BDBEC1',
  'padding': '12px',
  'display': 'flex',
  'justifyContent': 'center',
  'alignItems': 'center',
  'gap': '10px',
  'color': '#F5FAFF',
  'textAlign': 'center',
  'fontFamily': 'Inter',
  'fontSize': '14px',
  'fontStyle': 'normal',
  'fontWeight': 600,
  'lineHeight': '24px',
  'textTransform': 'none',
  '&:disabled': {
    color: '#F5FAFF',
  },
});
const ExportButton = styled(Button)({
  'borderRadius': '8px',
  'border': '1px solid #F5FAFF',
  'padding': '12px',
  'display': 'flex',
  'justifyContent': 'center',
  'alignItems': 'center',
  'gap': '10px',
  'height': '36px',
  'color': '#F5FAFF',
  'textAlign': 'center',
  'fontFamily': 'Inter',
  'fontSize': '14px',
  'fontStyle': 'normal',
  'fontWeight': 600,
  'lineHeight': '24px',
  'textTransform': 'none',
  '&:disabled': {
    border: '1px solid #BDBEC1',
    color: '#BDBEC1'
  },
});
const TicketButton = styled(Button)({
  border: '0px',
  padding: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  color: '#F5FAFF',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '24px',
  textTransform: 'none',
});


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#4A4C51',
    borderBottom: '1px solid #4A4C51',
    color: '#F5FAFF',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '18px',
    maxWidth: '20%',
  },
  [`&.${tableCellClasses.body}`]: {
    color: '#F5FAFF',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    borderBottom: '1px solid #4A4C51',
    textOverflow: 'ellipsis',
    maxWidth: '20%',
  },
}));

const HomePageStyledTableCell = styled(TableCell)({
  borderBottom: '1px solid #4A4C51',
  color: '#F5FAFF',
  fontFamily: 'Inter',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '18px',
  textOverflow: 'ellipsis',
  height: '30px',
  padding: '14px 16px'
});
const StyledSelect = styled(Select)({
  input: {
    padding: '0px'
  },
  icon: {
    fill: '#F5FAFF'
  },
});

const CustomSwitch = styled(Switch)(() => ({
  'width': 34,
  'height': 18,
  'padding': 0,
  '& .MuiSwitch-switchBase': {
    'padding': 1,
    '&.Mui-checked': {
      'transform': 'translateX(16px)',
      'color': 'white',
      '& .MuiSwitch-thumb:before': {
        color: '#0E8BFF',
        border: '6px solid #fff',
      },
      '& + .MuiSwitch-track': {
        background: '#4895EF',
        opacity: 1,
        border: 'none',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 16,
    height: 16,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#4A4C51',
    opacity: 1,
  },
}));

const CustomLabel = styled(FormControlLabel)({
  color: '#BDBEC1',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
  gap: '8px',
  marginBottom: '0px'
});

const VaultCustomLabel = styled(FormControlLabel)({
  color: '#F5FAFF',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
  gap: '8px',
  marginBottom: '0px'
});
const StyledInput = styled(InputBase)({
  borderRadius: 4,
  color: 'white',
  position: 'relative',
  backgroundColor: '#2E3036',
  fontSize: 16,
  width: '100%',
  padding: '10px 12px',
});
const StyledTabs = styled(Tabs)({
  color: '#F5FAFF',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '150%',
  borderBottom: '1px solid var(--Background-300, #2E3036)',
});
const StyledTab = styled(Tab)({
  'textTransform': 'none',
  'minWidth': '50px',
  'color': '#F5FAFF',
  '&.Mui-selected' : {
    color: '#F5FAFF',
  }
});
const StyledRadio = styled(Radio)({
  root: {
    color: '#4895EF',
  },
  checked: {},
});
const StyledLabel = styled(FormControlLabel)({
  root: {
    color: '#F5FAFF',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
  },
});
const LicenseButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  padding: '6px 12px',
  lineHeight: 1.5,
  backgroundColor: '#004F81',
  width: '150px',
});
const StyledCheckbox = styled(Checkbox)({
  'marginRight': '10px',
  'width': '16px',
  'height': '16px',
  'borderRadius': '4px',
  'border': '1.5px solid var(--gray-600, #434343)',
  'background': 'var(--gray-800, #212121)',
  '&.Mui-checked': {
    backgroundColor: '#FFF',
  },
});

const VaultClearButton = styled(Button)({
  border: 'none',
  padding: '6px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#F5FAFF',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '24px',
  textTransform: 'none'
});

const NoOutlineNoBackground = styled(Button)({
  'border': 'none',
  'padding': '6px',
  'display': 'flex',
  'justifyContent': 'center',
  'alignItems': 'center',
  'color': '#F5FAFF',
  'textAlign': 'center',
  'fontFamily': 'Inter',
  'fontSize': '14px',
  'fontStyle': 'normal',
  'fontWeight': 600,
  'lineHeight': '24px',
  'textTransform': 'none',
  '&:hover': {
    color: '#0E8BFF',
  },
});

const SideNavAccordion = styled(MuiAccordion)({
  'color': '#BDBEC1',
  'background': 'transparent',
  'boxShadow': 'none',
  '&:before': {
    display: 'none',
  },
  '&$expanded': {
    margin: '0px',
  },
});

const SideNavAccordionSummary = styled((props:any) => (
  <MuiAccordionSummary
    {...props}
  />
))(() => ({
  'color': '#BDBEC1',
  'fontFamily': 'Inter',
  'fontSize': '14px',
  'fontStyle': 'normal',
  'fontWeight': 600,
  'lineHeight': '24px',
  'marginBottom': -1,
  'minHeight': 56,
  '&$expanded': {
    minHeight: 56,
  },
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    gap: '16px',
    marginLeft: '14px'
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: '#BDBEC1',
  },
}));

const SideNavAccordionDetails = styled(MuiAccordionDetails)({
  padding: '0px'
});

const ModuleContentTooltip = styled(Tooltip)({
  tooltip: {
    display: 'flex',
    padding: 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderRadius: 'var(--radius-md, 8px)',
    background: 'var(--Background-200, #202227)',
    maxWidth: '400px'
  },
  arrow: {
    color: 'var(--Background-200, #202227)'
  }
});


export {
  StyledTabs,
  StyledTab,
  StyledInput,
  NextButton,
  BackButton,
  ExportButton,
  TicketButton,
  StyledTableCell,
  HomePageStyledTableCell,
  StyledSelect,
  CustomSwitch,
  CustomLabel,
  StyledLabel,
  StyledRadio,
  LicenseButton,
  StyledCheckbox,
  VaultClearButton,
  VaultCustomLabel,
  SideNavAccordion,
  SideNavAccordionDetails,
  SideNavAccordionSummary,
  NoOutlineNoBackground,
  ModuleContentTooltip
};
